import React from "react";
import { motion } from "framer-motion";
import bgImage from "../../assets/images/hero-image-22.jpg"; // ⭐ same background style
import img1 from "../../assets/images/img6.png";
import img2 from "../../assets/images/img4.png";
import img3 from "../../assets/images/img9.png";
import img4 from "../../assets/images/img7.png";
import img5 from "../../assets/images/img5.png";
import img6 from "../../assets/images/img1.png";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const ExpeditionsSection = () => {
  return (
    <section
      className="relative w-full text-white bg-cover bg-center bg-fixed overflow-hidden border-t border-neutral-800"
      style={{ backgroundImage: `url(${bgImage})` }} // ⭐ BACKGROUND ADDED
    >
      {/* Dark Overlay for better readability */}
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-24">

        {/* Header */}
        <div className="relative z-10 mb-10 sm:mb-14">

          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-6">

            {/* Left label */}
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-300 leading-tight">
              <p>[01]</p>
              <p>Expeditions</p>
            </div>

            {/* Big background heading */}
            <h3 className="
              font-bold text-white/30 leading-none select-none pointer-events-none
              text-[clamp(2.5rem,12vw,12.5rem)]
              text-center
            ">
              CLIENTS
            </h3>

            {/* Right meta */}
            <p className="
              text-[10px] sm:text-sm text-neutral-300
              text-center sm:text-right
              whitespace-normal sm:whitespace-nowrap
            ">
              Since 2020 – 2025
            </p>

          </div>
        </div>

        {/* 3 Column Grid */}
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="flex flex-col gap-6">
            <ProjectCard number="[01]" title="K2 Summit Expedition" year="2025" subtitle="High-Altitude Technical Climb" img={img1} aspect="aspect-square" />
            <ProjectCard number="[04]" title="Gasherbrum I" year="2024" subtitle="Alpine Style Expedition" img={img4} aspect="aspect-[0.76/1]" />
          </div>

          <div className="flex flex-col gap-6">
            <ProjectCard number="[02]" title="Broad Peak" year="2024" subtitle="Technical Ice & Rock" img={img2} aspect="aspect-[0.75/1]" />
            <ProjectCard number="[05]" title="Nanga Parbat" year="2024" subtitle="Rupal Face Challenge" img={img5} aspect="aspect-[0.75/1]" />
          </div>

          <div className="flex flex-col gap-6">
            <ProjectCard number="[03]" title="Everest South Col" year="2024" subtitle="World’s Highest Peak" img={img3} aspect="aspect-[0.97/1]" />
            <ProjectCard number="[06]" title="Karakoram Traverse" year="2024" subtitle="Glacier Crossing" img={img6} aspect="aspect-[4/3]" />
          </div>
        </div>

      </div>
    </section>
  );
};

const ProjectCard = ({ number, title, year, subtitle, img, aspect }) => (
  <motion.a
    href="#"
    className="group border border-white/20 bg-gray-700/40 backdrop-blur-md overflow-hidden cursor-pointer rounded-lg"
    variants={cardVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
  >
    {/* IMAGE */}
    <div className="relative">
      <p className="absolute top-3 left-4 text-xs tracking-[0.2em] text-neutral-300">
        {number}
      </p>

      <div className={`relative w-full ${aspect} overflow-hidden`}>
        <img
          src={img}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover transform transition-transform duration-[800ms] ease-[cubic-bezier(.22,.61,.36,1)] group-hover:scale-[1.08]"
        />
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition duration-500" />
      </div>
    </div>

    {/* TEXT */}
    <div className="flex items-center justify-between px-5 py-4 border-t border-white/10">
      <div>
        <h3 className="text-base sm:text-lg font-semibold leading-none">
          {title}
        </h3>
        <p className="text-xs text-neutral-300 mt-2">{subtitle}</p>
      </div>
      <p className="text-xs text-neutral-300">{year}</p>
    </div>
  </motion.a>
);

export default ExpeditionsSection;
